/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { pluginPostbackSetRefundStatusOrderRequestSchema } from "./pluginPostbackSetRefundStatusOrderRequestSchema.ts";

export const callbackPluginSetRefundStatusCreateStatus200Schema = z.any();

export const callbackPluginSetRefundStatusCreateResponseSchema = callbackPluginSetRefundStatusCreateStatus200Schema;

export const callbackPluginSetRefundStatusCreateDataSchemaJson = pluginPostbackSetRefundStatusOrderRequestSchema;

export const callbackPluginSetRefundStatusCreateDataSchemaXml = pluginPostbackSetRefundStatusOrderRequestSchema;

export const callbackPluginSetRefundStatusCreateDataSchema = z.union([
	callbackPluginSetRefundStatusCreateDataSchemaJson,
	callbackPluginSetRefundStatusCreateDataSchemaXml,
]);
